<template>
  <div @click.stop="expanded=!expanded">
    <div class="log-icon large-logo iconfont icon-users">
      <slot name="badge"/>
    </div>
    <div class="flex log-content">
      <div class="log-node-name">{{log.name}}</div>
      <div class="log-participant">
        {{log.items.length}}人{{({"and":"会签","or":"或签","one_by_one":"依次审批"}[log.activate])}}{{log.state===-1?"（审批中）":""}}
      </div>
      <div @click.stop="" v-show="expanded" class="layout participant-list">
        <div class="participant" v-for="(participant,index) in log.items" :key="index">
          <div class="participant-icon">
            <span>{{participant.participantName[0]}}</span>
          </div>
          <div class="participant-desc">{{participant.participantName}}</div>
        </div>
      </div>
    </div>
    <div>
      <div @click.stop="expanded=!expanded" class="toggle-expand"
           :class="expanded?'icon-arrow-up':'icon-arrow-down'"></div>
    </div>
  </div>
</template>

<script>
  import {Message} from "@maidi/common";
  import {InstanceService} from "../instance";

  export default {
    name: "log-group",
    props: ["log"],
    data() {
      return {reminded: false, expanded: this.log.state !== -2};
    },
    methods: {
    }
  }
</script>

<style scoped lang="scss">

</style>
